import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'react-toastify/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useTheme } from './store/use-theme';

function ThemedToastContainer() {
  const theme = useTheme((s) => s.theme);
  return <ToastContainer theme={theme === "dark" ? "dark" : "light"} />;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemedToastContainer />
    <App />
  </React.StrictMode>
);
